module.exports = __webpack_public_path__ + "img/Desk Stationary A04.f06cf68a.jpg";